var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketLauncher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.69 20.4976L115.245 17.7196L91.9669 17.8306L90.7444 17.2201H68.3539V18.5536L68.7424 19.4986H65.0749L64.7839 20.1091H63.1864V18.4981L61.8934 18.7756L61.9114 17.6641C61.9114 17.6641 60.9499 15.4831 55.8664 15.4006C50.7829 15.3166 49.2964 16.3861 49.2964 16.3861V18.5536L47.6164 19.1371L47.4079 18.1651H46.5739V16.3876L45.9274 16.3321L20.4829 15.8746L18.8794 17.1931L15.7684 18.0271H4.20043V20.2216H2.57593V32.2006H4.57543L5.24143 31.1941L7.29643 30.8821H16.8529V32.3056C16.8529 32.5006 15.7699 33.3556 15.7699 33.3556C15.7699 33.3556 14.6524 32.3491 14.2969 32.2006C13.9414 32.0521 13.8529 32.8141 13.9639 33.2776C14.0749 33.7411 15.6184 36.2341 15.7699 36.6661C15.9199 37.0981 15.0754 39.5026 14.9359 40.9516C14.7964 42.4006 15.9679 42.8911 16.2409 43.1116C16.5154 43.3321 19.1854 44.4106 19.1854 44.4106L19.7959 43.6666C19.7959 43.6666 20.5189 43.6666 21.1399 43.6111C21.7609 43.5556 22.4629 42.8821 22.4629 42.8821C22.4629 42.8821 23.4079 42.3316 23.3794 40.5661C23.3524 38.7991 22.8979 37.7236 22.8979 37.7236L22.0309 35.5546L23.2399 34.6096C23.2399 34.6096 23.8459 33.6631 23.9059 33.7201C23.9659 33.7786 23.1214 32.3806 23.1214 32.3806L24.7669 31.7761L25.6849 31.9411L25.5739 33.5521L28.0744 35.6626L28.6294 36.4411L30.6844 35.5516L35.3509 35.6626L43.4584 42.0406L43.8394 42.8791H50.3509C51.4069 42.4846 51.4354 40.5511 51.3514 39.3841C51.2674 38.2186 50.6254 37.2751 50.0179 35.8291C49.4104 34.3816 51.0079 33.4201 51.0079 33.4201L53.1979 32.4946H57.7399L58.6759 33.9256C58.6759 33.9256 58.7389 35.9371 58.7479 36.1006C58.7584 36.2641 59.1274 37.3831 59.1274 37.3831L62.1829 40.1611H64.0714L65.8789 38.3041C65.8789 38.3041 69.7624 35.5591 70.7944 34.8841C71.8264 34.2091 72.5719 34.3846 72.5719 34.3846L83.2939 34.1626L87.3499 32.6071H109.365L111.351 32.1076L112.49 33.1636H114.698L115.572 32.5531H117.35L117.458 29.4661C117.458 29.4661 118.319 25.9321 118.35 24.6076C118.382 23.2831 117.684 20.4961 117.684 20.4961L117.69 20.4976ZM14.4079 21.3871H8.46343C7.94143 21.3871 7.51843 20.9641 7.51843 20.4421C7.51843 19.9201 7.94143 19.4971 8.46343 19.4971H14.4079C14.9299 19.4971 15.3529 19.9201 15.3529 20.4421C15.3529 20.9641 14.9299 21.3871 14.4079 21.3871V21.3871ZM17.3254 39.5551C16.5199 39.8326 16.4089 40.1386 16.4089 40.1386C16.4089 40.1386 16.8814 36.8611 16.7149 35.5546C16.7149 35.5546 17.5204 34.9996 18.0754 35.5546C18.6304 36.1096 17.6029 36.1936 17.6029 36.8881C17.6029 37.5826 18.7144 37.7221 18.8524 38.6941C18.9919 39.6661 18.1294 39.2776 17.3239 39.5551H17.3254ZM27.2419 33.7216V30.8881H28.3534L30.6874 33.7216H27.2434H27.2419ZM46.5754 39.8881L45.9094 40.6111C45.9094 40.6111 46.0759 41.5006 45.6319 41.5561L38.7424 36.2221V34.2226L39.7429 32.7226H43.0204L43.6309 33.7231V34.7791L43.1869 35.5576H44.7979L45.1309 36.1681V37.1131L46.5754 38.2246V39.8911V39.8881ZM82.0219 19.8316H73.7854L75.5209 18.5536H82.0219V19.8316ZM88.8274 20.1646H84.6049C84.1594 20.1646 83.7994 19.8046 83.7994 19.3591C83.7994 18.9136 84.1594 18.5536 84.6049 18.5536H88.8274C89.2729 18.5536 89.6329 18.9136 89.6329 19.3591C89.6329 19.8046 89.2729 20.1646 88.8274 20.1646ZM105.551 20.1646H101.328C100.883 20.1646 100.523 19.8046 100.523 19.3591C100.523 18.9136 100.883 18.5536 101.328 18.5536H105.551C105.996 18.5536 106.356 18.9136 106.356 19.3591C106.356 19.8046 105.996 20.1646 105.551 20.1646Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9087 21.8294V23.3909H18.4637H20.9087V21.8294",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4634 23.3909V28.8854",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3257 23.3909L20.4922 28.8854",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8542 32.8589H33.6032",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2065 28.9964V31.7189H46.8275V30.9974H48.8555L51.0125 33.4214",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1597 18.7739V19.4969",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3542 18.7739V19.4969",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.911 26.4974V29.3579L51.521 29.8589V31.3994",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1322 26.4974V29.2199L62.6057 29.9984V31.3994",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.188 27.5804V31.0379",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6702 15.8729V20.6909",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1646 15.7454V20.6909",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9936 16.7745H53.2026V18.219H58.1646",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8267 27.1079V23.3909H54.3692H63.3272V25.9829",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3696 23.3909V25.0664H58.1646V23.5664",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3267 23.3909V26.0669",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8687 23.3909V26.3339",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.521 23.5245V26.316",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8267 26.4975V28.587H61.5772V26.316",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0229 19.4969H73.787",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0232 19.3574H83.8007",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6343 19.3574H100.163H106.356H109.995H116.811",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6877 19.3364H24.4507V28.5869",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57373 32.1991V20.2201H4.19823V18.0256H15.7692L18.8802 17.1916L20.0187 16.3861H46.5747V18.1636H47.4087V19.3366H48.2427V18.6631H49.2987V16.3846C49.2987 16.3846 49.4652 15.5881 55.4097 15.5881C61.3542 15.5881 61.8537 17.2741 61.8537 18.4396L63.1872 18.4951V20.1061H65.0757V19.4956H69.0207L68.3547 18.5506V17.2171H90.7452L91.9677 17.8276L115.246 17.7166L117.691 20.4946C117.691 20.4946 119.191 25.3276 117.691 28.6066L117.414 29.6626L117.358 32.5516H115.581L114.915 33.1621H112.081L111.358 32.1061L109.525 32.6056H87.3582L83.3022 34.1611L72.5802 34.3831C72.5802 34.3831 71.6352 34.3831 70.8027 34.8826C69.9687 35.3821 66.0807 38.1046 66.0807 38.1046L64.0812 40.1596H62.1927L59.1372 37.3816C59.1372 37.3816 58.6932 36.7156 58.7487 35.6041C58.8042 34.4926 58.6377 33.6046 58.6377 33.6046L57.7482 32.4931H52.9152L50.7477 33.5491C50.7477 33.5491 49.5252 34.2721 50.0247 35.8276C50.5242 37.3831 51.0807 37.7161 51.3582 39.3826C51.6357 41.0491 51.2472 42.4381 50.2467 42.9376H44.1912C44.1912 42.9376 43.5807 43.1041 43.6917 42.2146L35.3577 35.6581H30.1902L28.6347 36.4366C28.6347 36.4366 28.0242 36.4921 28.0797 35.6581L25.5792 33.5476L25.6902 31.9366L24.9672 31.3261L24.5787 32.2156L22.5792 32.4376L23.9127 33.7156C23.9127 33.7156 24.0792 34.2706 23.2467 34.6051L22.4127 34.9381C22.4127 34.9381 21.6897 35.1046 22.2462 36.3271C22.8027 37.5496 23.6352 38.8831 23.4132 40.3546C23.1912 41.8276 23.4132 43.3831 20.7462 43.6606H19.8012L19.1907 44.4046L16.2462 43.1056C16.2462 43.1056 14.6352 42.0496 14.9682 40.1056C15.3012 38.1616 15.6912 37.0966 15.6912 37.0966C15.6912 37.0966 15.7467 35.9671 15.1917 34.8976C14.6367 33.8281 13.9692 33.2731 13.9692 33.2731C13.9692 33.2731 13.5252 32.0086 14.3022 32.1961C15.0792 32.3836 16.0242 33.6616 16.0242 33.6616C16.0242 33.6616 16.1907 32.7166 16.8582 32.6056V30.8761H7.07523L6.35223 31.1881H5.24073L5.18523 32.1946H2.57373V32.1991Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2424 30.8867H28.3524L30.6864 33.7202H27.2424V30.8867Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.742 32.7197H43.0195L43.63 33.7202V34.7762L43.186 35.5547H44.797L45.13 36.1652V37.1102L46.5745 38.2217V39.8882L45.9085 40.6112C45.9085 40.6112 46.075 41.5007 45.631 41.5562L38.7415 36.2222V34.2227L39.742 32.7227V32.7197Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2056 33.0226H44.5136L45.3056 33.5881V34.6921L44.7986 35.5531",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3541 26.9971V30.5521C50.3541 30.5521 50.3256 31.3996 51.3681 31.3996H65.2026L68.3691 31.0666L73.7856 30.9826V27.3151L68.3691 27.4396C68.3691 27.4396 67.4946 27.3841 66.8691 26.9956C66.2436 26.6071 65.7441 25.7731 64.6191 25.7731C63.4941 25.7731 63.4101 26.2726 63.1611 26.3146C62.9106 26.3566 51.4101 26.3146 51.4101 26.3146C51.4101 26.3146 50.3541 26.2171 50.3541 26.9956V26.9971Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7856 29.7332H87.2856L89.7021 30.4832H111.953",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M117.689 20.4976H115.412H113.078L112.162 21.6916V33.1636",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M115.579 32.5531V20.4976",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5415 27.2867V26.1077H68.743V22.9967H67.5415V19.4972",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7856 19.8302L75.5211 18.5522H82.0221V19.8302H73.7856Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8283 18.5522H84.6058C84.1609 18.5522 83.8003 18.9128 83.8003 19.3577C83.8003 19.8026 84.1609 20.1632 84.6058 20.1632H88.8283C89.2732 20.1632 89.6338 19.8026 89.6338 19.3577C89.6338 18.9128 89.2732 18.5522 88.8283 18.5522Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M105.55 18.5522H101.327C100.883 18.5522 100.522 18.9128 100.522 19.3577C100.522 19.8026 100.883 20.1632 101.327 20.1632H105.55C105.995 20.1632 106.355 19.8026 106.355 19.3577C106.355 18.9128 105.995 18.5522 105.55 18.5522Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19946 20.2187V32.1992",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M15.769 18.0242H28.9645L30.6865 19.3367H32.242V18.0527L33.2425 17.6642H40.6315V18.7472H47.41",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8521 30.8792V21.8297H22.0196V29.0807H28.1306L29.4086 28.5872H35.7416L36.7421 29.0807H44.8541H50.3546",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9641 31.3307H16.8521",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7142 35.5531C16.7142 35.5531 17.5197 34.9981 18.0747 35.5531C18.6297 36.1081 17.6022 36.1921 17.6022 36.8866C17.6022 37.5811 18.7137 37.7206 18.8517 38.6926C18.9897 39.6646 18.1287 39.2761 17.3232 39.5536C16.5177 39.8311 16.4067 40.1371 16.4067 40.1371C16.4067 40.1371 16.8792 36.8596 16.7127 35.5531H16.7142Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.407 19.4972H8.46404C7.94213 19.4972 7.51904 19.9199 7.51904 20.4414C7.51904 20.9629 7.94213 21.3857 8.46404 21.3857H14.407C14.929 21.3857 15.352 20.9629 15.352 20.4414C15.352 19.9199 14.929 19.4972 14.407 19.4972Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2986 18.6632V20.6912H52.3676L53.0336 20.4002H56.0336L56.5331 20.6912H58.9076L59.4071 21.2327C59.4071 21.2327 61.2401 21.3992 61.6571 20.5247C62.0741 19.6502 61.8521 18.4412 61.8521 18.4412",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7847 19.4971V22.7326H46.2427V26.1496H47.4097V27.1081H50.3542",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLauncher);
export default __webpack_public_path__ + "static/media/Rocket Launcher.307ee8da57a50007fcd2d5f41c00f6ef.svg";
export { ForwardRef as ReactComponent };